'use client';
import { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';

import { useSiteStore } from '@/store/site';
import { useAuthToken } from '@/store/auth';

const SportEditModal = dynamic(
	() => import('./sport-edit-modal').then(m => m.SportEditModal),
	{ ssr: false }
);

export const SportEditModalLoader = () => {
	const isShowEditSport = useSiteStore(state => state.isShowEditSport);
	const hasAuthToken = Boolean(useAuthToken());
	const [shouldRender, setShouldRender] = useState(false);

	useEffect(() => {
		if (hasAuthToken && isShowEditSport) {
			setShouldRender(true);
		}
	}, [hasAuthToken, isShowEditSport]);

	if (!hasAuthToken || !shouldRender) {
		return null;
	}

	return <SportEditModal />;
};